import request from '@/utils/request'
//收款编码列表
export function shipmentPaidRecord(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2CollectionCode',
        method: 'get',
        params: query
    })
}
//收款方列表
export function partyBalanceStatistics(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2CollectionCode/queryCollectionCodeParty',
        method: 'get',
        params: query
    })
}
// 新增收款方
export function CollectionCode(data) {
    return request({
        url: '/ntocc-tms-api/myBankV2CollectionCode',
        method: 'post',
        params: data
    })
}
// 云起付二期 获取列表
export function getArpaWithdraw(query) {
    return request({
        url: '/ntocc-tms-api/arpaWithdraw',
        method: 'get',
        params: query
    })
}
// 提现记录
export function ArpaWithdrawRecord(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2WithdrawalRecord',
        method: 'get',
        params: query
    })
}
// 更新提现记录列表
export function updateWithdrawRecord(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2WithdrawalRecord/refreshStatus',
        method: 'post',
        params: query
    })
}
// 提现详情
export function WithdrawalData(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2CollectionCode/queryWithdrawalData',
        method: 'post',
        params: query
    })
}
//收款记录
export function CollectionRecord(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2CollectionRecord',
        method: 'get',
        params: query
    })
}
//退款记录
export function RefundLog(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2RefundLog',
        method: 'get',
        params: query
    })
}
//更新退款状态
export function refreshStatus(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2RefundLog/refreshStatus',
        method: 'post',
        params: query
    })
}
//同步收款记录
export function syncCloudData(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2CollectionRecordSync/syncCloudData',
        method: 'post',
        params: query
    })
}
//确认收款
export function confirmReceipt(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2CollectionRecord/confirmReceipt',
        method: 'post',
        params: query
    })
}
//退款详情
export function queryRefundData(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2CollectionRecord/queryRefundData',
        method: 'post',
        params: query
    })
}
//发送验证码
export function sendWsWithdrawCode(query) {
    return request({
        url: '/ntocc-tps-api/sms/sendWsWithdrawCode',
        method: 'post',
        params: query
    })
}
//提现
export function withdrawal(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2WithdrawalRecord/withdrawal',
        method: 'post',
        params: query
    })
}
//退款
export function refund(query) {
    return request({
        url: '/ntocc-tms-api/myBankV2RefundLog/refund',
        method: 'post',
        params: query
    })
}